var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05669 0L13.0918 4.61597L14.0224 7.81891L9.24025 9.81399L3.08105 4.63206L3.98377 1.00728L7.05669 0ZM4.52067 2.06811L9.63285 5.97814L9.06746 8.57276L3.96901 4.28327L4.52067 2.06811ZM9.85143 8.61869L13.0546 7.28236L12.5195 5.44059L10.392 6.13797L9.85143 8.61869ZM10.1378 5.30224L11.8617 4.73716L6.9258 0.961973L5.20189 1.52705L10.1378 5.30224ZM1.43961 8.25412L6.5518 12.1642L5.98641 14.7588L0.887955 10.4693L1.43961 8.25412ZM6.77038 14.8047L10.032 13.444L9.75885 11.2504L7.31585 12.3015L6.77038 14.8047ZM7.04075 11.476L10.3858 10.0369L10.883 14.0293L6.1592 16L0 10.8181L0.90271 7.19329L3.80438 6.24215L4.01599 7.09185L2.12084 7.71307L7.04075 11.476ZM16 11.7687L14.4948 8.31494L11.998 9.46074V13.4905L16 11.7687ZM12.7683 12.2153V10.059L14.1229 9.43743L14.9285 11.2859L12.7683 12.2153Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterial);
export default __webpack_public_path__ + "static/media/material.fd2c2e63a3dbdd018f66f43aa5cad8a9.svg";
export { ForwardRef as ReactComponent };